// validators/indoPhoneLocal.js (opsional dipisah file)
import { helpers } from "vuelidate/lib/validators";

// true jika kosong -> biar aturan `required` yang mengurus
export const indoPhoneLocal = helpers.withParams(
  { type: "indoPhoneLocal", msg: "Harus mulai dengan 8 dan 10–14 digit" },
  value => {
    if (!helpers.req(value)) return true;                // biarkan `required` yang validasi kosong
    const v = String(value).replace(/\s+/g, "");         // buang spasi
    return /^8\d{9,11}$/.test(v);                        // total 10–14 digit, diawali 8
  }
);

//wajib 4 digit angka
export const fourDigits = helpers.withParams(
  { type: "fourDigits", msg: "Harus 4 digit angka" },
  value => {
    if (!helpers.req(value)) return true;          // biar rule 'required' yang urus kosong
    const v = String(value).trim();
    return /^\d{4}$/.test(v);                      // tepat 4 digit
  }
);